import PropTypes from 'prop-types';

function LaserOverlay({
    cursorRef,
    cursorStyle,
    laserRef,
    laserStyle,
}) {
    return (
        <>
            <canvas ref={laserRef} style={laserStyle} aria-hidden="true" />
            <div ref={cursorRef} style={cursorStyle} aria-hidden="true" />
        </>
    );
}

LaserOverlay.propTypes = {
    cursorRef: PropTypes.shape({
        current: PropTypes.instanceOf(Element),
    }).isRequired,
    cursorStyle: PropTypes.shape({
        backgroundColor: PropTypes.string,
        borderRadius: PropTypes.string,
        boxShadow: PropTypes.string,
        height: PropTypes.string,
        left: PropTypes.string,
        opacity: PropTypes.number,
        pointerEvents: PropTypes.string,
        position: PropTypes.string,
        top: PropTypes.string,
        transform: PropTypes.string,
        transition: PropTypes.string,
        width: PropTypes.string,
        zIndex: PropTypes.number,
    }).isRequired,
    laserRef: PropTypes.shape({
        current: PropTypes.instanceOf(Element),
    }).isRequired,
    laserStyle: PropTypes.shape({
        height: PropTypes.string,
        inset: PropTypes.number,
        pointerEvents: PropTypes.string,
        position: PropTypes.string,
        width: PropTypes.string,
        zIndex: PropTypes.number,
    }).isRequired,
};

export default LaserOverlay;
